export default __webpack_public_path__ + "static/papiermark-b85f7aa886a162329dc94416a0ca5db6.jpeg";